// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__SampleLessons-module--ZUOKd {
    background: var(--color-surface-inverse);
    color: var(--color-neutral-100);
    padding: 0 var(--space-md) var(--space-3xl);
}

.inner__SampleLessons-module--c2HYV {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
    padding-top: var(--space-2xl);
    border-top: 1px solid var(--color-neutral-700);
}

.head__SampleLessons-module--bCz_O {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    gap: var(--space-md);
}

.heading__SampleLessons-module--qfyV0 {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
    color: var(--color-text-on-brand);
}

.intro__SampleLessons-module--A9QCw {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    max-width: 440px;
}

.intro__SampleLessons-module--A9QCw p {
    margin: 0;
    font-size: 16px;
    color: var(--color-neutral-300);
}

.note__SampleLessons-module--MI_5T {
    font-size: 14px;
    color: var(--color-neutral-400);
}

/* 4 columns at desktop, 2x2 at tablet, 1 at mobile - never a 3+1 row. */
.grid__SampleLessons-module--Ebj_m {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: var(--space-sm);
}

/* Six lessons (India) fill two rows of three rather than leaving a 4+2. Before the media queries so they win. */
.gridThree__SampleLessons-module--T8qYA {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 900px) {
    .grid__SampleLessons-module--Ebj_m {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 560px) {
    .grid__SampleLessons-module--Ebj_m {
        grid-template-columns: minmax(0, 1fr);
    }
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/SampleLessons.module.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,+BAA+B;IAC/B,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,6BAA6B;IAC7B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA,wEAAwE;AACxE;IACI,aAAa;IACb,gDAAgD;IAChD,oBAAoB;AACxB;;AAEA,gHAAgH;AAChH;IACI,gDAAgD;AACpD;;AAEA;IACI;QACI,gDAAgD;IACpD;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ","sourcesContent":[".section {\n    background: var(--color-surface-inverse);\n    color: var(--color-neutral-100);\n    padding: 0 var(--space-md) var(--space-3xl);\n}\n\n.inner {\n    max-width: 1200px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n    padding-top: var(--space-2xl);\n    border-top: 1px solid var(--color-neutral-700);\n}\n\n.head {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: var(--space-md);\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    color: var(--color-text-on-brand);\n}\n\n.intro {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n    max-width: 440px;\n}\n\n.intro p {\n    margin: 0;\n    font-size: 16px;\n    color: var(--color-neutral-300);\n}\n\n.note {\n    font-size: 14px;\n    color: var(--color-neutral-400);\n}\n\n/* 4 columns at desktop, 2x2 at tablet, 1 at mobile - never a 3+1 row. */\n.grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: var(--space-sm);\n}\n\n/* Six lessons (India) fill two rows of three rather than leaving a 4+2. Before the media queries so they win. */\n.gridThree {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 900px) {\n    .grid {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 560px) {\n    .grid {\n        grid-template-columns: minmax(0, 1fr);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `section__SampleLessons-module--ZUOKd`,
	"inner": `inner__SampleLessons-module--c2HYV`,
	"head": `head__SampleLessons-module--bCz_O`,
	"heading": `heading__SampleLessons-module--qfyV0`,
	"intro": `intro__SampleLessons-module--A9QCw`,
	"note": `note__SampleLessons-module--MI_5T`,
	"grid": `grid__SampleLessons-module--Ebj_m`,
	"gridThree": `gridThree__SampleLessons-module--T8qYA`
};
export default ___CSS_LOADER_EXPORT___;
